// extracted by mini-css-extract-plugin
export default {"imgbox":"SubBanner_imgbox__0QJSd","center":"SubBanner_center__sdZn7","head":"SubBanner_head__IxbGs","subHead":"SubBanner_subHead__NwwqM"};